import { render, staticRenderFns } from "./aftersale_send_sale.vue?vue&type=template&id=2068a850"
import script from "./aftersale_send_sale.vue?vue&type=script&lang=js"
export * from "./aftersale_send_sale.vue?vue&type=script&lang=js"
import style0 from "./aftersale_send_sale.vue?vue&type=style&index=0&id=2068a850&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports